import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Calendar: React.FC<IconProps> = ({
                                                   fill = COLORS.FG.SOFT,
                                                   width = 24,
                                                   height = 24,
                                                   className,
                                               }) => {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Communication / Calendar" width="24.000000" height="24.000000" x="0.000000" y="0.000000"/>
            <path id="Union"
                  d="M15.5 4.5L15.5 6.5L17 6.5L17 4.5L18 4.5C18.8284 4.5 19.5 5.17157 19.5 6L19.5 8.01562L4.5 8.01562L4.5 6C4.5 5.17157 5.17157 4.5 6 4.5L7 4.5L7 6.5L8.5 6.5L8.5 4.5L15.5 4.5ZM4.5 9.51562L4.5 18C4.5 18.8284 5.17157 19.5 6 19.5L18 19.5C18.8284 19.5 19.5 18.8284 19.5 18L19.5 9.51562L4.5 9.51562ZM6 3L7 3L7 1L8.5 1L8.5 3L15.5 3L15.5 1L17 1L17 3L18 3C19.6569 3 21 4.34315 21 6L21 18C21 19.6569 19.6569 21 18 21L6 21C4.34315 21 3 19.6569 3 18L3 6C3 4.34315 4.34315 3 6 3Z"
                  fill={fill} fillRule="evenodd"/>
        </svg>
    );
};
